require.context('./', true, /\.styl$/);
